<template>
  <div class="about">
    <img :src="bannerImg" class="bannerImg" />
    <an-child>
      <div slot="c_left" class="left_nav">
  	 	<h3 class="title-color"><a>{{$store.state.langData.about}}</a></h3>
        <ul>
          <li v-for="(item,index) in cleft" :key="index">
            <router-link :to="'/about?type='+item.type" exact>{{item.title}}</router-link>
          </li>
        </ul>
      </div>
      <div slot="c_right">
		      <div class="bread d-flex">
		          <h3 class="flex-auto"><a class="text-blue">{{title}}</a></h3>
		          <div class="text-gray_dark d-flex">
		            <span><img src="@/assets/images/p.png" class="pic"></span>
		            {{$store.state.langData.nowAddress}}：           
		            <router-link :to="'/about?type='+type">{{$store.state.langData.about}}</router-link>>
		            <a>{{title}}</a>
		          </div>
		      </div>
	      <div v-html="aboucompany.content"></div>
      </div>
    </an-child>
  </div>
</template>

<script>
import { getBanner } from "@/api";
import {getAboutList,getAbout,getRecruiList } from "@/api/hjy";
export default {
  name: "about",
  data(){
        return {
            cleft:[],
            bannerImg:'',//banner
            aboucompany:{},
            bannerShow:false,
            type:'',
            recList:[],
            totalPages:0,//总页数
            currentPage:1,//当前页数
            startPage:1,//开始页
            endPage:1,//结束页
        }
    },

    //请求方法
    methods:{
      //获取分类
      getAboutList(){
        getAboutList()
        .then(res => this.cleft.push(...res.list))
        .catch(e => console.log(e))
      },

      // 获取banner
      getBannerImg(){
        getBanner({'params':'2','ad_type':'2'}).then(res => {
          (this.bannerImg = res.list[0].imageUrl)
        });
      	this.bannerShow = true;
      },
      // 获取富文本
      getAboutText(){
        getAbout({'type':this.$route.query.type}).then(res => {
          this.type = this.$route.query.type;
          (this.aboucompany = res.aboucompany)
        });
      },
    },
    computed:{
      title(){
        let type=this.$route.query.type;
        let t='';
        this.cleft.map(n=>{
          if (n.type==type){
            t=n.title;
            return;
          }
        });
        this.getAboutText();
        return t;
      },
      type(){
        return this.cleft.length>0?this.cleft[0].type:''
      }
    },
    mounted(){
      this.getAboutList();
      this.getBannerImg();
    }
};
</script>
<style lang="stylus">
  .bannerImg
    width 1200px
    height auto 
    margin 15px auto
    display block
  .about
    padding-bottom 88px
  table
    width 100%
    border-collapse collapse
    border-spacing 0
    border:solid #E4EAEC
    border-width 1px 0px 0px 1px
    thead
      th
        background #F3F3F4
        font-size 14px
        width 25%
        color #666
        font-weight normal
        line-height 48px
    tbody
      td
        text-align center
        line-height 60px
        font-size 14px
      td:nth-child(2)
        color #1278C6
        font-weight bold
      td:nth-child(4)
        a
          width 94px
          height 32px
          line-height 32px
          color #ffffff
          background #1278C6
          border-radius 4px
          display block
          margin 0 auto
</style>

